// Secciones repetibles que se pueden dejar vacias: cuentan como completas si no tienen contenido.
export const OPTIONAL_REPEATABLE_SECTION_IDS = [7, 9, 10, 11, 12];

// Formulario con todos los datos obligatorios completos. Es la misma regla con la que se guarda el
// formulario y con la que se habilita la descarga del PDF de investigacion (SMP-399).
export const esFormularioSrtCompleto = (
    sectionsStatus: Record<number, boolean>,
    sectionsWithContent: Record<number, boolean>
): boolean =>
    Object.keys(sectionsStatus).every((id) => {
        const numId = Number(id);
        return OPTIONAL_REPEATABLE_SECTION_IDS.includes(numId)
            ? sectionsStatus[numId] || !sectionsWithContent[numId]
            : sectionsStatus[numId];
    });
